import React, { useEffect, useRef, useState } from 'react';
import './SplashScreen.css';

const TAGS = [
  { label: 'Spot it',            emoji: '📍', color: '#E53935', delay: 0.05, pos: 'tl' },
  { label: 'Rent it',            emoji: '🔑', color: '#7C3AED', delay: 0.12, pos: 'tr' },
  { label: 'Radar View',         emoji: '📡', color: '#0891B2', delay: 0.19, pos: 'ml' },
  { label: 'Direct Owner',       emoji: '🤝', color: '#059669', delay: 0.26, pos: 'mr' },
  { label: 'Rent in Minutes',    emoji: '⚡', color: '#D97706', delay: 0.33, pos: 'bl' },
  { label: 'Ultra Fast',         emoji: '🚀', color: '#DB2777', delay: 0.4,  pos: 'br' },
];

export default function SplashScreen({ onDone }) {
  const [visibleTags, setVisibleTags] = useState([]);
  const [leaving, setLeaving]         = useState(false);

  // Pop tags in one by one
  useEffect(() => {
    const timers = TAGS.map((t, i) =>
      setTimeout(() => setVisibleTags(v => [...v, i]), t.delay * 1000)
    );
    return () => timers.forEach(clearTimeout);
  }, []);

  // Leave after all tags shown. onDone is read via a ref so this timer is
  // scheduled exactly once, even if the parent passes a new function identity
  // on every re-render (which would otherwise reset the countdown each time).
  const onDoneRef = useRef(onDone);
  useEffect(() => { onDoneRef.current = onDone; }, [onDone]);

  useEffect(() => {
    const last = TAGS[TAGS.length - 1].delay * 1000 + 300;
    const t = setTimeout(() => {
      setLeaving(true);
      setTimeout(() => onDoneRef.current(), 250);
    }, last);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className={`splash${leaving ? ' splash-leave' : ''}`}>
      <div className="splash-stage">

        {/* Floating tags */}
        {TAGS.map((tag, i) => (
          <div
            key={tag.pos}
            className={`splash-tag splash-tag--${tag.pos}${visibleTags.includes(i) ? ' visible' : ''}`}
            style={{ '--tag-color': tag.color }}
          >
            <span className="splash-tag-emoji">{tag.emoji}</span>
            <span className="splash-tag-label">{tag.label}</span>
          </div>
        ))}

        {/* Centre logo */}
        <div className="splash-center">
          <div className="splash-icon-wrap">
            <div className="splash-icon-bg" />
            <svg className="splash-icon-svg" width="44" height="44" viewBox="0 0 24 24" fill="#fff">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
            </svg>
          </div>
          <div className="splash-brand">
            Spacz<span className="splash-brand-o">O</span>
          </div>
          <div className="splash-sub">India's Zero Brokerage Platform</div>
          <div className="splash-dots">
            <span /><span /><span />
          </div>
        </div>

      </div>
    </div>
  );
}
